import { HttpErrorResponse } from '@angular/common/http';
import {
  AfterViewChecked,
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  RFQStatus,
  RFQStatusLabel,
  TemplateType,
  TemplateTypeLabel,
} from 'src/app/shared/constants/constants';
import {
  PAGE_SIZE_OPTIONS,
  rfqTemplateTypes,
  getRFQTemplateLabel,
} from 'src/app/shared/utils';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common-services/common.service';
import { Subject, debounceTime } from 'rxjs';
import { RfqService } from '../services/rfq.service';
import { PageEvent } from '@angular/material/paginator';
import { FormControl } from '@angular/forms';
import { ChatboxComponent } from 'src/app/shared/elements/chatbox/chatbox.component';
import { RfqDetailComponent } from '../rfq-detail/rfq-detail.component';

export interface PeriodicElement {
  id: number;
  name: string;
  email: string;
  company: string;
  phoneno: number;
  location: string;
  highlighted?: boolean;
  status: string;
}
@Component({
  selector: 'app-lead-management',
  templateUrl: './lead-management.component.html',
  styleUrls: ['./lead-management.component.scss'],
})
export class LeadManagementComponent implements OnInit {
  RFQStatus: any = RFQStatus;
  TemplateType: any = TemplateType;
  ishidden = false;
  baseUrl = environment.BASE_URL;
  rightPanelActive: boolean = false;
  selectedRfq: any = {};
  status: string = 'QUOTE_IN_PROGRESS';
  searchText: string = '';
  filterIdsList: any = [];
  totalDraftRfq: any;
  draftRfqPopupKey: any;
  RFQStatusLabel: any = RFQStatusLabel;
  TemplateTypeLabel: any = TemplateTypeLabel;
  filtersData: any = [];
  filtersDataChildLevel: any = [];
  filtersDataInnerChildLevel: any = [];
  isDraft: boolean = false;
  isArchive: boolean = false;
  PAGE_SIZE_OPTIONS: any = PAGE_SIZE_OPTIONS;
  companyId: string = '';
  rfqList: any = [];
  rfqDetailData: any;

  totalElements = 0;
  pageNumber = 0;
  pageSize = 10;
  totalPages = 0;
  sortBy = 'pinnedOrder';
  direction = 'desc';

  baseInfo: any = {
    baseUrl: this.baseUrl,
  };

  // searchText = '';
  private searchInput$: Subject<string> = new Subject();

  rfqTemplateTypes = rfqTemplateTypes;
  rfqFormControl = new FormControl(this.rfqTemplateTypes[0].label);
  selectedTemplateType = '';

  @ViewChild('dynamicContainer', { read: ViewContainerRef, static: false })
  chatContainer!: ViewContainerRef;

  constructor(
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    public rfqService: RfqService
  ) {
    this.companyId = sessionStorage.getItem('customercompanyId') || '';
  }

  ngOnInit(): void {
    this.getRfqsCount();
    this.getInProgressRfqsList();
    this.RFQFiltersList();
    this.setupSearchDebouncer();
  }

  toggleVisibility() {
    this.rfqService.showDraftMessage = false;
  }

  RFQFiltersList() {
    let apiURL = `${this.baseUrl}rfq`;
    this.commonService.getData(apiURL).subscribe((res: any) => {
      this.filtersData = res.response;
      this.initializeCheckboxes(this.filtersData, false);
    });
  }

  getChilds(item: any) {
    this.filtersDataChildLevel = item.sub;
    this.filtersDataInnerChildLevel = [];
  }

  getInnerChilds(item: any) {
    this.filtersDataInnerChildLevel = item.sub;
  }

  onCheckboxChange(item: any) {
    if (!item.isChecked) this.initializeCheckboxes(item.sub, false);
  }

  selectParentFromChild(item: any) {
    if (item.isChecked) {
      this.filtersData.forEach((value: any) => {
        if (value.sub.find((x: any) => x.id == item.id)) value.isChecked = true;
      });
    }
  }

  selectParentFromInnerChild(item: any) {
    if (item.isChecked) {
      this.filtersDataChildLevel.forEach((value: any) => {
        if (value.sub.find((x: any) => x.id == item.id)) value.isChecked = true;
        this.selectParentFromChild(value);
      });
    }
  }

  initializeCheckboxes(data: any[], isChecked: boolean) {
    if (data?.length > 0)
      data?.forEach((item: any) => {
        item['isChecked'] = isChecked;
        if (item?.sub?.length) {
          this.initializeCheckboxes(item.sub, isChecked);
        }
      });
  }

  applyFilter() {
    this.collectSelectedFilterIds(this.filtersData);
    let queryParams = {
      status: this.status,
      page: 0,
      sortBy: 'pinnedOrder',
      direction: 'desc',
      size: 100,
    };
    this.getRfqsList(queryParams);
  }

  collectSelectedFilterIds(data: any[]) {
    data.forEach((item: any) => {
      if (
        item.name != 'Category' ||
        'Material' ||
        'Secondary Process' ||
        'Industry'
      ) {
        if (
          item.isChecked &&
          !this.filterIdsList.includes(item.id) &&
          !item?.sub?.filter((x: any) => x.isChecked == true).length
        ) {
          this.filterIdsList.push(item.id);
        }
        if (item.sub.length) this.collectSelectedFilterIds(item.sub);
      }
    });
  }

  displayedColumns: string[] = [
    'select',
    'id',
    'name',
    'email',
    'company',
    'phoneno',
    'location',
    'status',
    'actions',
  ];

  ngAfterViewChecked(): void {}

  openRfqQuote(rfq?: any, event?: any) {
    this.rightPanelActive = !this.rightPanelActive;
    this.selectedRfq = rfq;
    event.preventDefault();
    document.body.classList.add('rfqboxOpen');
  }

  openUpdteRfq(rfq: any) {
    this.router.navigate(['rfq/create-rfq', rfq?.id]);
  }

  closeRfqQuote(event: any) {
    this.rightPanelActive = !this.rightPanelActive;
    document.body.classList.remove('rfqboxOpen');
  }
  onChildClose() {
    this.rightPanelActive = !this.rightPanelActive;
    document.body.classList.remove('rfqboxOpen');
  }

  idTrackFn = (item: any) => {};

  getInProgressRfqsList() {
    this.status = RFQStatus.QUOTE_IN_PROGRESS;
    let queryParams = {
      status: this.status,
      page: 0,
      sortBy: 'pinnedOrder',
      direction: 'desc',
      size: 100,
    };
    this.isArchive = false;
    this.getRfqsList(queryParams);
  }

  getArchiveRfqsList() {
    this.status = RFQStatus.RFQ_DISCONTINUED;
    let queryParams = {
      status: this.status,
      page: 0,
      sortBy: 'pinnedOrder',
      direction: 'desc',
      size: 100,
    };
    this.isArchive = true;
    this.getRfqsList(queryParams);
  }

  getDraftRfqsList() {
    this.status = RFQStatus.DRAFT;
    let queryParams = {
      status: this.status,
      page: 0,
      sortBy: 'pinnedOrder',
      direction: 'desc',
      size: 100,
    };
    this.getRfqsDraftsList(queryParams);
  }

  getDraftRfqsListPopup() {
    this.status = RFQStatus.DRAFT;
    let queryParams = {
      status: this.status,
      page: 0,
      sortBy: 'pinnedOrder',
      direction: 'desc',
      size: 100,
    };
    this.getRfqsDraftsList(queryParams);

    const value = 'clicked';
    this.rfqService.setValue(value);
    this.rfqService.showDraftMessage = false;
  }

  getRfqsCount() {
    this.status = RFQStatus.DRAFT;
    let apiUrl = `${this.baseUrl}rfq/customer/getAll?status=${this.status}&page=0&sortBy=pinnedOrder&direction=desc&size=100`;
    let payload = {
      filterIds: this.filterIdsList,
      customerId: Number(this.companyId),
    };
    this.commonService
      .postDatawithoutHeaders(apiUrl, payload)
      .subscribe((data) => {
        this.totalDraftRfq = data?.response?.totalElements;
      });
  }

  getRFQtemplateType(rfqFormControl: FormControl) {
    this.selectedTemplateType = rfqFormControl.value;
    let queryParams = {
      status: this.status,
      page: 0,
      sortBy: 'pinnedOrder',
      direction: 'desc',
      size: 100,
    };
    this.getRfqsList(queryParams);
  }

  getRfqsList(queryParams: any) {
    let apiUrl = this.isArchive
      ? `${this.baseUrl}rfq/customer/getAll?rfqTemplate=${this.selectedTemplateType}&page=${queryParams.page}&sortBy=${queryParams.sortBy}&direction=${queryParams.direction}&size=${queryParams.size}&status=${queryParams.status}`
      : `${this.baseUrl}rfq/customer/getAll?rfqTemplate=${this.selectedTemplateType}&page=${queryParams.page}&sortBy=${queryParams.sortBy}&direction=${queryParams.direction}&size=${queryParams.size}`;
    let payload = {
      // filterIds: this.filterIdsList,
      customerId: Number(this.companyId),
    };
    this.commonService.postDatawithoutHeaders(apiUrl, payload).subscribe({
      next: (res: any) => {
        this.rfqList = res?.response?.list;
        this.totalElements = res?.response?.totalElements;
        this.pageSize = res?.response?.size;
        this.totalPages = res.response.totalPages;
        if (this.status == RFQStatus.DRAFT) {
          this.isDraft = true;
          this.isArchive = false;
        }
        if (this.status == RFQStatus.ARCHIVE) {
          this.isArchive = true;
          this.isDraft = false;
        }
        if (this.status == RFQStatus.QUOTE_IN_PROGRESS) {
          this.isDraft = false;
          this.isArchive = false;
        }
        if (this.status == RFQStatus.RFQ_DISCONTINUED) {
          this.isDraft = false;
          this.isArchive = true;
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      },
    });
  }
  getRfqsDraftsList(queryParams: any) {
    let apiUrl = `${this.baseUrl}rfq/customer/getAll?status=${queryParams.status}&page=${queryParams.page}&sortBy=${queryParams.sortBy}&direction=${queryParams.direction}&size=${queryParams.size}`;
    let payload = {
      filterIds: this.filterIdsList,
      customerId: this.companyId,
    };
    this.commonService.postDatawithoutHeaders(apiUrl, payload).subscribe({
      next: (res: any) => {
        this.rfqList = res?.response?.list;
        if (this.status == RFQStatus.DRAFT) {
          this.isDraft = true;
          this.isArchive = false;
        }
        if (this.status == RFQStatus.ARCHIVE) {
          this.isArchive = true;
          this.isDraft = false;
        }
        if (this.status == RFQStatus.QUOTE_IN_PROGRESS) {
          this.isDraft = false;
          this.isArchive = false;
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      },
    });
  }

  setupSearchDebouncer() {
    this.searchInput$.pipe(debounceTime(1000)).subscribe((term: string) => {
      this.searchText = term;
      this.searchRfq();
    });
  }

  searchRFQBy(event: any): void {
    this.searchText = event.target.value;
    this.searchInput$.next(this.searchText);
  }

  searchRfq() {
    let queryParams = {
      status: this.status,
      page: 0,
      sortBy: 'pinnedOrder',
      direction: 'desc',
      size: 100,
      text: this.searchText,
    };
    let apiUrl;
    if (queryParams.status === RFQStatus.RFQ_DISCONTINUED) {
      apiUrl = `${this.baseUrl}rfq/customer/getAll?page=${queryParams.page}&sortBy=${queryParams.sortBy}&direction=${queryParams.direction}&size=${queryParams.size}&text=${queryParams.text}&status=${queryParams.status}`;
    } else {
      apiUrl = `${this.baseUrl}rfq/customer/getAll?page=${queryParams.page}&sortBy=${queryParams.sortBy}&direction=${queryParams.direction}&size=${queryParams.size}&text=${queryParams.text}`;
    }

    let payload = {
      filterIds: this.filterIdsList,
      customerId: this.companyId,
    };
    this.commonService
      .postDatawithoutHeaders(apiUrl, payload)
      .pipe(debounceTime(1000))
      .subscribe({
        next: (res: any) => {
          this.rfqList = res?.response?.list;
        },
        error: (error: HttpErrorResponse) => {
          console.log(error);
        },
      });
  }

  currentIndex(event: any) {}

  getRfqCustomerDetail(customerRfqPrimaryId: number) {
    let apiUrl = `${this.baseUrl}rfq/customer/rfq/get/${customerRfqPrimaryId}`;
    this.commonService.getData(apiUrl).subscribe((data) => {
      this.rfqDetailData = data.response;
    });
  }

  bookmarkRFQ(event: Event, rfqData: any) {
    event.stopPropagation();
    let statusUpdate = !rfqData.pinned;
    let apiurl = `${this.baseUrl}rfq/common/updateBookmark/customer/${rfqData.id}/${statusUpdate}`;
    this.commonService.update(apiurl, '', {}).subscribe({
      next: (res: any) => {
        let queryParams = {
          status: this.status,
          page: 0,
          sortBy: 'pinnedOrder',
          direction: 'desc',
          size: 100,
        };
        if (queryParams.status === 'DRAFT') {
          this.getRfqsDraftsList(queryParams);
        } else {
          this.getRfqsList(queryParams);
        }
      },
    });
  }

  trackCourse(index: number, rfq: any) {
    return rfq ? rfq.id : undefined;
  }

  updateRfqListData(event: any) {
    this.rightPanelActive = !this.rightPanelActive;
    document.body.classList.remove('rfqboxOpen');
    this.getInProgressRfqsList();
  }
  getStatusLabel(status: any): string {
    if (status) {
      const label = this.RFQStatusLabel[status];
      return label;
    }
    return '';
  }

  getRFQTemplateLabel(rfqType: TemplateType): string {
    return getRFQTemplateLabel(rfqType);
  }

  filterSearch(event: any): void {
    this.filterIdsList = event;
    let queryParams = {
      status: this.status,
      page: 0,
      sortBy: 'pinnedOrder',
      direction: 'desc',
      size: 100,
    };
    this.getRfqsList(queryParams);
  }

  pageChange(event: PageEvent) {
    // this.filterIdsList = event;
    let queryParams = {
      status: this.status,
      page: event.pageIndex,
      sortBy: 'id',
      direction: 'asc',
      size: event.pageSize,
    };
    this.getRfqsList(queryParams);
    // this.getRfqsList(event.pageSize, event.pageIndex);
  }

  clearTextSearch(): void {
    const event = {
      target: {
        value: '',
      },
    };
    this.searchText = '';
    this.searchRfq();
  }
  ngAfterViewInit() {
    if (!this.chatContainer) {
      console.error('ViewContainerRef not found!');
    }
  }
  async loadChatBox(event: any, id: number, name: string) {
    event.stopPropagation();
    const { ChatboxComponent } = await import(
      '../../../shared/elements/chatbox/chatbox.component'
    );
    const chatCompRef = this.chatContainer.createComponent(ChatboxComponent);
    const rfqDetails = chatCompRef.instance;
    rfqDetails.rfqInfo = {
      id: id,
      rfqName: name,
    };
    //rfqID.id = id; // Pass the ID dynamically
    chatCompRef.instance.close = () => {
      event.stopPropagation();
      this.chatContainer.clear();
    };
  }
  onScroll() {
    if (this.pageNumber + 1 < this.totalPages) {
      this.pageNumber++;
      this.appendData();
    }
  }
  appendData() {
    let apiUrl = this.isArchive
      ? `${this.baseUrl}rfq/customer/getAll?rfqTemplate=${this.selectedTemplateType}&page=${this.pageNumber}&sortBy=${this.sortBy}&direction=${this.direction}&size=${this.pageSize}&status=${this.status}`
      : `${this.baseUrl}rfq/customer/getAll?rfqTemplate=${this.selectedTemplateType}&page=${this.pageNumber}&sortBy=${this.sortBy}&direction=${this.direction}&size=${this.pageSize}`;
    let payload = {
      // filterIds: this.filterIdsList,
      customerId: Number(this.companyId),
    };
    this.commonService
      .postDatawithoutHeaders(apiUrl, payload)
      .subscribe((data) => {
        if (data?.response.list) {
          this.rfqList = [...this.rfqList, ...data?.response.list];
        }
      });
  }
  viewRfqDetails(event: any, id: number, name: string) {
    event.stopPropagation();
    const chatCompRef = this.chatContainer.createComponent(RfqDetailComponent);
    const rfqDetails = chatCompRef.instance;
    rfqDetails.rfqInfo = {
      id: id,
      rfqName: name,
    };
    chatCompRef.instance.close = () => {
      event.stopPropagation();
      this.chatContainer.clear();
    };
    chatCompRef.instance.updateRfqListData = () => {
      this.chatContainer.clear();
      this.getInProgressRfqsList();
    };
  }
}
